import { inject, Injectable } from '@angular/core';
import { AuthenticatedJsonClientService } from '../core/authenticated-json-client.service';

export interface AskDiscoveryDecisionQuestionInput {
  assignmentId: string;
  expectedContentRevision: number;
  expectedResponseRevision: number;
  expectedContractHash: string;
  expectedPresentationRevision: number;
  expectedPresentationHash: string;
  modelRoute: string;
  question: string;
  turnId: string;
  idempotencyKey: string;
}

export interface AskDiscoveryDecisionQuestionResponse {
  turnId: string;
  status: 'accepted' | 'pending';
}

interface WireResponse {
  discoveryAssignmentId?: unknown;
  turnId?: unknown;
  status?: unknown;
}

@Injectable({ providedIn: 'root' })
export class DecisionAssistantApiService {
  private readonly client = inject(AuthenticatedJsonClientService);

  async ask(
    input: AskDiscoveryDecisionQuestionInput,
  ): Promise<AskDiscoveryDecisionQuestionResponse> {
    const response = await this.client.post<WireResponse>('/askdiscoverydecisionquestion', {
      idempotencyKey: input.idempotencyKey,
      discoveryAssignmentId: input.assignmentId,
      turnId: input.turnId,
      expectedContentRevision: input.expectedContentRevision,
      expectedResponseRevision: input.expectedResponseRevision,
      expectedContractHash: input.expectedContractHash,
      presentationRevision: input.expectedPresentationRevision,
      presentationHash: input.expectedPresentationHash,
      modelRoute: input.modelRoute,
      question: input.question,
    });
    if (
      response.discoveryAssignmentId !== input.assignmentId ||
      response.turnId !== input.turnId ||
      response.turnId.length === 0 ||
      response.turnId.length > 128 ||
      (response.status !== 'accepted' && response.status !== 'pending')
    )
      throw new Error('The AI assistant returned an invalid response. Try again.');
    return { turnId: response.turnId, status: response.status };
  }
}
